import { combineReducers } from 'redux';
import supplyArticle from './supplyArticle';

export default combineReducers({ supplyArticle });
